import { takeEvery, call, put,delay } from "redux-saga/effects";
import { FETCH_DOCUMENT_REQUEST } from '../actions';
import doctorService from "../services/doctorService";
import * as actions from "../actions";
import { errorResponsesArray } from '../utils/helper'
import { slackDebugger } from '../utils/slackDebugger'

export function* watcherDocumentSaga() {
  yield takeEvery(FETCH_DOCUMENT_REQUEST, documentSaga);
}

function* documentSaga(action) {
  try {
    yield delay(3000)
    const response = yield call(doctorService.fetchDocuments,action.patientId,action.visitId);
    yield put( actions.fetchDocumentSuccess(response.data.data) );
  } catch (error) {
    if(errorResponsesArray.includes(parseInt(error.response.status))){
      slackDebugger({
       actionType:"errorLogging",
       errorMessage:error.response.statusText,
       errorCode : error.response.status,
       endPoint:'get_patient_documents_by_visit_id',
       method:'GET',
     })
    }
    yield put( actions.fetchDocumentFailure(error) );
  }
}


